import { schema } from 'normalizr';

export const qrCode = new schema.Entity('qrcodes');
export const qrCodes = new schema.Array(qrCode);
